"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlParsingError = exports.ReverseUrlRoutingError = void 0;
class ReverseUrlRoutingError extends Error {
    constructor(message, cause) {
        super(`Could not generate URL route: ${message}`, cause ? { cause } : undefined);
    }
}
exports.ReverseUrlRoutingError = ReverseUrlRoutingError;
class UrlParsingError extends Error {
    constructor(message, cause) {
        super(`Could not parse URL: ${message}`, cause ? { cause } : undefined);
    }
}
exports.UrlParsingError = UrlParsingError;
//# sourceMappingURL=error.js.map